import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, mapTo } from 'rxjs/operators';
import { convertApiPaymentCardDetails, PaymentCard } from '../payment-card/payment-card';
import {
  DeletePaymentCardRequest,
  ListPaymentCardsRequest,
  ListPaymentCardsResponse,
  PaymentMethodApiService,
  SetDefaultPaymentMethodRequest,
} from '@vendasta/billing';

@Injectable({ providedIn: 'root' })
export class PaymentMethodService {
  constructor(private apiService: PaymentMethodApiService) {}

  listPaymentCards(merchantId: string, customerId: string): Observable<PaymentCard[]> {
    const req = new ListPaymentCardsRequest({
      merchantId,
      customerId,
    });
    return this.apiService.listPaymentCards(req).pipe(
      map((resp: ListPaymentCardsResponse) => {
        return (resp && resp.paymentCard ? resp.paymentCard : []).map((c) => convertApiPaymentCardDetails(c));
      }),
    );
  }

  deletePaymentCard(merchantId: string, cardId: string): Observable<boolean> {
    const req = new DeletePaymentCardRequest({
      merchantId,
      cardId,
    });
    return this.apiService.deletePaymentCard(req).pipe(mapTo(true));
  }

  setDefaultPaymentCard(merchantId: string, customerId: string, paymentMethodId: string): Observable<boolean> {
    const req = new SetDefaultPaymentMethodRequest({
      merchantId,
      customerId,
      paymentMethodId,
    });
    return this.apiService.setDefaultPaymentMethod(req).pipe(mapTo(true));
  }
}
